import Jsona, { SwitchCaseJsonMapper } from 'jsona'
import { irwin } from 'config'
import { httpClient } from './httpClient'
import { snakeCase } from 'change-case-object'
import { cancellableQuery } from './utils'

const deserializerAndCase = new Jsona({
  jsonPropertiesMapper: new SwitchCaseJsonMapper({ switchChar: '_' }),
})

function client() {
  return httpClient(irwin.baseUrl)
}

const searchFundsAdminQuery = async (params, signal) => {
  const hasPagination = params.page_size !== undefined && params.page_offset !== undefined

  const response = await client().get('/v2/funds/admin_search', {
    params,
    signal,
  })

  return {
    data: deserializerAndCase.deserialize(response),
    ...(hasPagination && {
      links: response.links,
      count: response.meta.total,
    }),
  }
}

async function searchFundsAdmin(params) {
  return cancellableQuery(searchFundsAdminQuery, snakeCase(params))
}

export { searchFundsAdmin }
